import "../../styles/UserDashboard/ListEnergy.scss";
import SideBar from "../../components/UserDashboard/SideBar";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import EnergyHeader from "../../components/energy/energyHeader";
import { useForm } from "react-hook-form";
import { lgaList } from "../../data/nigerianStatesData";
import { EnergyTradingIntegration } from "../../instantiateTransaction/EnergySharing";
import { useSelector } from "react-redux";
import EnergySharingContract from "../../Abi/EnergySharingContract.json";
import Web3 from "web3";
import { toast } from "react-toastify";
import { ethers, Interface } from "ethers";
import { web2ListEnergyBuy, web2ListEnergySell } from "../../apis/energySharing";
import { getUserInfo } from "../../apis/General/users";

export default function ListEnergy() {
  const auth = useSelector((state) => state.auth);

  const [generalLoading, setGeneralLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [web3, setWeb3] = useState(null);
  const [stage, setStage] = useState(1);
  const [tab, setTab] = useState("buy");
  const [account, setAccount] = useState(null);
  const [values, setValues] = useState(null);
  const [excessEnergyBalance, setExcessEnergyBalance] = useState(null);
  const navigate = useNavigate();
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();
  const [priceRange, setPriceRange] = useState(null);


  useEffect(() => {
    if (tab === "sell") {
      const fetchPriceRange = async () => {
        const integration = new EnergyTradingIntegration("seller");
        try {
          await integration.init();
          const range = await integration.getPlatformPriceRange();
          console.log("Fetched platform price range from contract:", range);
          setPriceRange(range);
        } catch (e) {
          console.error(" Failed to fetch platform price range from contract:", e);
        }
      };

      fetchPriceRange();
    }
  }, [tab]);


  useEffect(() => {
    console.log("register", register);
  }, [register]);

  const handleBack = () => {
    if (stage === 2) {
      setStage(1);
    } else {
      navigate("/energy");
    }
  };
  const onSubmit = (data) => {
    console.log("data", data);

    setValues(data);
    setStage(2);
  };
  const states = Object.keys(lgaList).sort();


  useEffect(() => {
    if (window.ethereum) {
      const web3Instance = new Web3(window.ethereum);
      setWeb3(web3Instance);
      window.ethereum
        .request({ method: "eth_requestAccounts" })
        .then((accounts) => setAccount(accounts[0]))
        .catch((err) => {
          alert(
            "Please allow access to your MetaMask wallet to enable you List you energy"
          );
          console.error("User denied account access", err);
        });
    } else {
      console.error(
        "MetaMask is not installed. Please install it to use this app."
      );
    }
  }, []);


  useEffect(() => {
    const fetchExcessEnergyBalance = async () => {
      if (!account) {
        setExcessEnergyBalance(null);
        return;
      }
      try {
        const integration = new EnergyTradingIntegration("seller");
        await integration.init();
        const balance = await integration.getExcessEnergyBalance(account);
        setExcessEnergyBalance(balance);
        console.log("Excess Energy Balance:", balance);
        console.log("account connected for balance check:", account);

      } catch (error) {
        setExcessEnergyBalance(null);
        console.error("Failed to fetch excess energy balance", error);
      }
    };

    fetchExcessEnergyBalance();
  }, [account]); // This will re-run when account changes

  // ENERGY_TRADING_ROUTER_ADDRESS: "0x0a8e92f31ab4af618F546BF114D62A2dbF13e286",
  const contractAddress = "0xb763ecF4323B5ce42c5D6a39Cc0E11c712fE104b";
  const contractABI = EnergySharingContract.abi;

  const contract = web3
    ? new web3.eth.Contract(contractABI, contractAddress)
    : null;


  const handleListEnergySell = async () => {
    console.log("Trying to list:", values?.amountTo);
    setLoading(true);

    if (!contract || !account) {
      alert("Wallet not connected");
      setLoading(false);
      return;
    }

    try {
      // Initialize integration
      const integration = new EnergyTradingIntegration("seller");
      await integration.init();

      // Fetch the most current excess energy balance
      const currentExcessEnergyBalance = await integration.getExcessEnergyBalance(account);
      console.log("Current Excess Energy Balance:", currentExcessEnergyBalance);

      // Check if user has enough excess energy balance
      if (Number(values?.amountTo) > Number(currentExcessEnergyBalance)) {
        alert(`You cannot list more energy than your available excess energy balance. Available: ${currentExcessEnergyBalance} kWh`);
        setLoading(false);
        return;
      }

      console.log("Listing parameters:", {
        energyType: "solar energy",
        excessEnergyKW: values?.amountTo,
        userId: auth?.userInfo?.id,
        quantity: values?.amountTo,
        pricePerUnit: values?.rate,
        location: ethers.encodeBytes32String(`${values?.address} ${values?.houseNumber}`),
        minPurchaseAmount: values?.minQuantity,
        maxPurchaseAmount: values?.maxQuantity
      });

      // Create listing with order
      const response = await integration.createListingWithOrder({
        energyType: "solar energy",
        excessEnergyKW: Number(values?.amountTo),
        pricePerUnit: Number(values?.rate),
        location: `${values?.address} ${values?.houseNumber}`,
        minPurchaseAmount: Number(values?.minQuantity),
        maxPurchaseAmount: Number(values?.maxQuantity),
      });

      let listingId = null;

      // Create ethers Interface instance for log parsing
      const iface = new Interface(EnergySharingContract.abi);

      // Try to find the event in the logs
      for (const log of response.logs) {
        try {
          const parsed = iface.parseLog(log);
          if (parsed.name === "ListingCreated" || parsed.name === "ListingAndOrderCreated") {
            listingId = parsed.args.listingId.toString();
            break;
          }
        } catch (e) {
          // Continue to next log if parsing fails
        }
      }

      if (listingId) {
        console.log("Payload to backend for SELL listing:", {
          listingId: listingId,
          rate: values?.rate,
          amount: Number(values?.amountTo),
          stateOfOrigin: values?.stateOfOrigin,
          range: {
            min: values?.minQuantity,
            max: values?.maxQuantity
          },
          houseNumber: values?.houseNumber,
          address: values?.address,
          token: auth?.token
        });

        const backendResponse = await web2ListEnergySell(
          listingId,
          values?.rate,
          Number(values?.amountTo),
          values?.stateOfOrigin,
          {
            min: values?.minQuantity,
            max: values?.maxQuantity
          },
          values?.houseNumber,
          values?.address,
          auth?.token,
        );

        console.log("Backend response:", backendResponse);

        // Check if backend call was successful
        if (backendResponse?.data?.statusCode === 200) {
          // Update the local excess energy balance state after successful listing
          const updatedBalance = await integration.getExcessEnergyBalance(account);
          setExcessEnergyBalance(updatedBalance);

          // Success message for seller
          toast.success(
            `Successfully listed ${values?.amountTo} kWh for sale at ₦${values?.rate}/kWh!`,
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            }
          );

          // Navigate after a short delay to allow user to see the message
          setTimeout(() => {
            navigate("/energy-listing");
          }, 2000);
        } else {
          // Backend call failed
          throw new Error(backendResponse?.data?.message || "Backend creation failed");
        }
      } else {
        throw new Error("Could not extract listing ID from blockchain transaction");
      }

      setLoading(false);
    } catch (error) {
      console.error("Energy Listing Failed", error);
      toast.error(`Failed to list energy: ${error.message}`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setLoading(false);
    }
  };

  const handleListEnergyBuy = async () => {
    setLoading(true);
    console.log("Creating energy demand...");

    if (!values?.amountTo || !values?.rate || !values?.minQuantity || !values?.maxQuantity) {
      alert("Please fill in all required fields");
      setLoading(false);
      return;
    }

    try {
      // Create demand on blockchain
      const integration = new EnergyTradingIntegration("buyer");
      await integration.init();

      const response = await integration.createDemandWithOrder({
        energyType: "solar energy",
        quantity: Number(values?.amountTo),
        pricePerUnit: Number(values?.rate),
        location: `${values?.address} ${values?.houseNumber}`,
        minSellAmount: Number(values?.minQuantity),
        maxSellAmount: Number(values?.maxQuantity),
      });

      let demandId = null;

      // Create ethers Interface instance for log parsing
      const iface = new Interface(EnergySharingContract.abi);

      // Try to find the demand creation event in the logs
      for (const log of response.logs) {
        try {
          const parsed = iface.parseLog(log);
          if (parsed.name === "DemandCreated" || parsed.name === "DemandAndOrderCreated") {
            demandId = parsed.args.demandId.toString();
            break;
          }
        } catch (e) {
          // Continue to next log if parsing fails
        }
      }

      if (demandId) {
        // Create backend record
        const backendResponse = await web2ListEnergyBuy(
          demandId,
          Number(values?.rate),
          Number(values?.amountTo),
          values?.stateOfOrigin,
          {
            min: values?.minQuantity,
            max: values?.maxQuantity
          },
          values?.houseNumber,
          values?.address,
          auth?.token,
        );


        if (backendResponse?.data?.statusCode === 200) {
          // Success message for demand created
          toast.success(
            `Successfully created demand for ${values?.amountTo} kWh at ₦${values?.rate}/kWh!`,
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            }
          );

          setTimeout(() => {
            navigate(`/energy-listing/${values?.amountTo}`);
          }, 2000);
        } else {
          toast.error(backendResponse?.data?.message || "Backend creation failed", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        }
      } else {
        console.error("Could not extract demand ID from transaction");
        toast.error("Demand created on blockchain but could not get demand ID", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } catch (error) {
      console.error("Energy Demand Creation Failed", error);
      toast.error(`Failed to create energy demand: ${error.message}`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="energyOverview">
      <div className="sidebar_container">
        <SideBar />
      </div>
      <div className="energyOverview__inner">
        <EnergyHeader />
        <div className="listEnergy__back" onClick={handleBack}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19.0004 11.0006H7.83041L12.7104 6.12065C13.1004 5.73065 13.1004 5.09065 12.7104 4.70065C12.6179 4.60794 12.508 4.5344 12.387 4.48421C12.2661 4.43403 12.1364 4.4082 12.0054 4.4082C11.8744 4.4082 11.7448 4.43403 11.6238 4.48421C11.5028 4.5344 11.3929 4.60794 11.3004 4.70065L4.71041 11.2906C4.61771 11.3832 4.54416 11.493 4.49398 11.614C4.4438 11.735 4.41797 11.8647 4.41797 11.9956C4.41797 12.1266 4.4438 12.2563 4.49398 12.3773C4.54416 12.4982 4.61771 12.6081 4.71041 12.7006L11.3004 19.2906C11.393 19.3832 11.5029 19.4567 11.6239 19.5068C11.7448 19.5569 11.8745 19.5827 12.0054 19.5827C12.1363 19.5827 12.266 19.5569 12.387 19.5068C12.5079 19.4567 12.6178 19.3832 12.7104 19.2906C12.803 19.1981 12.8764 19.0882 12.9265 18.9672C12.9766 18.8462 13.0024 18.7166 13.0024 18.5856C13.0024 18.4547 12.9766 18.3251 12.9265 18.2041C12.8764 18.0831 12.803 17.9732 12.7104 17.8806L7.83041 13.0006H19.0004C19.5504 13.0006 20.0004 12.5506 20.0004 12.0006C20.0004 11.4506 19.5504 11.0006 19.0004 11.0006Z"
              fill="black"
            />
          </svg>
          Back
        </div>
        <form className="listEnergy__form" onSubmit={handleSubmit(onSubmit)}>
          {stage === 1 && (
            <>
              <div className="listEnergy__form__tabs">
                <div
                  className={tab === "buy" && "listEnergy__form__tabs__active"}
                  onClick={() => setTab("buy")}
                >
                  Buy
                </div>
                <div
                  className={tab === "sell" && "listEnergy__form__tabs__active"}
                  onClick={() => setTab("sell")}
                >
                  Sell
                </div>
              </div>

              {/* SELLER PRICE INPUT WITH RANGE */}
              {tab === "sell" && (
                <>
                  <label className="listEnergy__form__label" htmlFor="rate">
                    At what rate (Price)
                    <span style={{ fontSize: 14, marginLeft: 8 }}>
                      {priceRange && (
                        <span>(Allowed: ₦{priceRange.min} - ₦{priceRange.max} per kWh)</span>
                      )}
                    </span>
                  </label>
                  <div className="listEnergy__form__input">
                    <div className="listEnergy__form__input__unit">₦/kWh</div>
                    <input
                      type="number"
                      placeholder="0.00"
                      name="rate"
                      min={priceRange ? priceRange.min : undefined}
                      max={priceRange ? priceRange.max : undefined}
                      step="1"
                      {...register("rate", {
                        required: true,
                        min: priceRange?.min ?? 0,
                        max: priceRange?.max ?? Infinity,
                        valueAsNumber: true,
                      })}

                    />
                  </div>
                </>
              )}
              {/* BUYER PRICE INPUT (DISABLED) */}
              {tab === "buy" && (
                <>
                  <label className="listEnergy__form__label" htmlFor="rate">
                    At what rate (Price)
                  </label>
                  <div className="listEnergy__form__input">
                    <div className="listEnergy__form__input__unit">₦/kWh</div>
                    <input
                      type="number"
                      placeholder="0.00"
                      name="rate"
                      value={"40"}
                      required
                      disabled
                    />
                  </div>
                </>
              )}
              <div className="listEnergy__form__guide">
                1.00 kWh = ₦{tab === "sell" ? (values?.rate || priceRange?.min || 0) : 40}

              </div>
              <label className="listEnergy__form__label" htmlFor="">
                {tab === "buy" && <div>Amount to buy (Energy)</div>}
                {tab === "sell" && <div>Amount to sell (Energy)</div>}

                {tab === "buy" && (
                  <div>
                    Balance: <span>0.00kWh</span>
                  </div>
                )}
                {tab === "sell" && (
                  <div>
                    Balance: <span>{excessEnergyBalance !== null ? excessEnergyBalance : ""}kWh</span>
                  </div>
                )}
              </label>
              <div className="listEnergy__form__input">
                <div className="listEnergy__form__input__unit">kWh</div>
                <input
                  type="number"
                  placeholder="0.00"
                  name="amountTo"
                  {...register("amountTo")}
                  required
                />
              </div>
              {/* <div className="listEnergy__form__guide">
                1.00 kWh = ₦40
              </div> */}

              <div className="listEnergy__form__input-group">
                <div>
                  <label className="listEnergy__form__label" htmlFor="">
                    State
                  </label>
                  <select
                    id=""
                    className="listEnergy__form__input"
                    name="stateOfOrigin"
                    {...register("stateOfOrigin")}
                    required
                  >
                    <option value="">Select State</option>
                    {states?.map((item) => (
                      <option value={item}>{item}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="listEnergy__form__label" htmlFor="">
                    House Number
                  </label>
                  <input
                    type="text"
                    placeholder="House Number"
                    className="listEnergy__form__input"
                    name="houseNumber"
                    {...register("houseNumber")}
                    required
                  />
                </div>
              </div>
              <div className="listEnergy__form__input-group">
                <div>
                  <label className="listEnergy__form__label" htmlFor="">
                    Minimum Purchase Quantity
                  </label>
                  <div className="listEnergy__form__input">
                    <div className="listEnergy__form__input__unit">kWh</div>
                    <input
                      type="number"
                      placeholder="0.00"
                      name="amountTo"
                      {...register("minQuantity")}
                      required
                    />
                  </div>
                </div>
                <div>
                  <label className="listEnergy__form__label" htmlFor="">
                    Maximum Purchase Quantity
                  </label>
                  <div className="listEnergy__form__input">
                    <div className="listEnergy__form__input__unit">kWh</div>
                    <input
                      type="number"
                      placeholder="0.00"
                      name="amountTo"
                      {...register("maxQuantity")}
                      required
                    />
                  </div>
                </div>
              </div>
              <label className="listEnergy__form__label" htmlFor="">
                Address
              </label>
              <input
                type="text"
                placeholder="Address"
                className="listEnergy__form__input"
                name="address"
                {...register("address")}
                required
              />

              <button className="listEnergy__form__button" type="submit">
                Proceed
              </button>
            </>
          )}

          {stage === 2 && (
            <>
              <div className="listEnergy__summary">
                <div className="listEnergy__summary__title">
                  <div>Listing Summary</div>
                  <div>₦{values?.rate}/kWh</div>
                  {/* <div>₦40/kWh</div> */}
                </div>

                <div className="listEnergy__summary__divide"></div>

                <div className="listEnergy__summary__subtitle">
                  {tab === "buy" && <div>Amount to buy</div>}
                  {tab === "sell" && <div>Amount to sell</div>}
                  <div>{values?.amountTo} kWh</div>
                </div>
                <div className="listEnergy__summary__subtitle">
                  <div>Energy limit</div>
                  <div>{values?.rate} kWh</div>
                  {/* <div>40 kWh</div> */}
                </div>
                <div className="listEnergy__summary__subtitle">
                  <div>State</div>
                  <div>{values?.stateOfOrigin}</div>
                </div>
                <div className="listEnergy__summary__subtitle">
                  <div>House number</div>
                  <div>{values?.houseNumber}</div>
                </div>
                <div className="listEnergy__summary__subtitle">
                  <div>Address</div>
                  <div>{values?.address}</div>
                </div>

                <div className="listEnergy__summary__terms">
                  <input type="checkbox" name="" id="" />
                  <div>
                    I agree to the <a href="">Terms of Service</a>
                  </div>
                </div>

                <div className="listEnergy__summary__buttons">
                  <button type="button" onClick={handleBack}>
                    Cancel
                  </button>
                  <button type="button" onClick={tab === "sell" ? handleListEnergySell : handleListEnergyBuy} disabled={loading}>
                    {loading ? "Loading..." : "Yes, Proceed to list"}
                  </button>
                </div>
              </div>
            </>
          )}
        </form>
      </div>
    </div>
  );
}
